<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!-- 重要指标 -->
    <index-common v-if="page.isIndex"
                  v-loading="loading.indexLoading"
                  element-loading-background="#FFF"
                  element-loading-spinner="el-icon-loading"
                  element-loading-customClass="defineLoading"
                  element-loading-text="拼命的加载中"
                  class="block-preview noCompare_min"
                  :options="summaryList">
    </index-common>
    <!-- 趋势图 -->
    <chart-content>
      <div>
        <div v-for="(item,index) in list"
             :key="index"
             style="float:left;width:46%;margin-right:30px;">
          <div class="flex-between gragh-index">
            <!-- 图的指标 -->
            <SelectIndex :class-key="item.chartKey"
                         number="1"
                         address="center"
                         :indextt="index">
            </SelectIndex>
          </div>
          <VueColumn id="chart"
                     :v-loading="item.chartLoading"
                     element-loading-background="#FFF"
                     element-loading-spinner="el-icon-loading"
                     element-loading-customClass="defineLoading"
                     element-loading-text="拼命的加载中"
                     style="height:400px"
                     :options="item.option">
          </VueColumn>
        </div>
      </div>
      <!-- 1个图 -->

    </chart-content>
    <SelectDrop :class-key="page.tableKey"
                number="20"
                address="bottom">
    </SelectDrop>
  </div>
</template>

<script>
import * as Api from "../../../common/report.api";
import * as queryUtil from "../../../common/query";
import * as util from "../../../common/util";
import * as consts from "../../../common/const";
import * as classCharts from "../chart/style_charts";
import * as Func from "../../../common/commonFun";
export default {
  components: {
    IndexCommon: resolve => require(["./index_common"], resolve),
    ChartContent: resolve => require(["./chart-content"], resolve),
    // 图指标不分类
    SelectIndex: resolve => require(["../select/select_indexTwo"], resolve),
    // 表指标不分类
    SelectDrop: () => import("../select/select_drop"),
    // 表指标分类
    SelectClass: () => import("../select/select_class"),
    // 柱状图
    VueColumn: () => import("../chart/vue-column")
  },
  props: {
    page: [Object],
    headerVal: [Object],
    header: [Object],
    keyList: [Array]
  },
  data() {
    return {
      list: [],
      loading: {
        indexLoading: false
      },
      // 指标
      summaryList: [],
      indexList: this.$store.state.indexList,
      indexLists: []
    };
  },
  created() {
    this.keyList.forEach(item => {
      this.list.push({
        chartLoading: false,
        option: {}
      });
    });
  },
  computed: {
    queryTable() {
      let tableData = {};
      tableData = Object.assign(
        {},
        tableData,
        this.$store.state.query_common,
        this.$store.state.query_table
      );
      // console.log(this.$store.state.query_common,
      //   this.$store.state.query_table,);
      return this.getTable(tableData);
    },
    queryData() {
      let chart = {};
      chart = Object.assign({}, chart, this.$store.state.query_common);
      return this.getChart(chart);
    }
  },
  watch: {
    indexList: {
      deep: true,
      handler: function(v) {
        // console.log(v,34);
        if (v.length === 2) {
          this.indexLists = v;
        }
      }
    },
    queryTable() {},
    queryData() {}
  },
  methods: {
    // 查询表格和重要指标
    getTable(params) {
      // console.log(params);
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0 &&
        this.page.isIndex
      ) {
        Func.getIndex(this, params);
        return params;
      }
    },
    get(v) {},
    // 查询chart
    async getChart(params) {
      if (this.$route.name === this.page.name) {
        params.constantType = this.page.ChartconstantType;
        if (this.indexLists.length) {
          for (let i = 0; i < this.keyList.length; i++) {
            params.indicatorIDs = this.indexLists[i].indicatorIDs;
            params.constantKey = this.keyList[i].constantKey;
            params.identifyKey = this.keyList[i].identifyKey;
            await this.getColumn(this.list[i], params);
          }
        }

        // if(this.page.chartSort){
        //    // 排序的柱状图
        //   Func.getSortCloumn(this,params)
        // }else{
        //    // 不排序的柱状图
        //   Func.getCloumn(this,params)
        // }
      } else {
        return {};
      }
      return params;
    },
    getColumn(ele, params) {
      return new Promise((resolve, reject) => {
        ele.chartLoading = true;
        Api.getTrends(params)
          .then(res => {
            // console.log('78');
            ele.chartLoading = false;
            if (res.data && res.data.errorCode === 0 && res.data.data) {
              // let a = res.data.data
              // let data = way.sortTwoData(a)
              let column = queryUtil.setTrendSerise(res.data.data);
              ele.option = Object.assign(
                {},
                ele.option,
                classCharts.chartColumn(column)
              );
            } else {
              ele.option = Object.assign(
                {},
                ele.option,
                classCharts.chartColumn()
              );
            }
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    change_header(val) {
      let tab = util.byWatch(val, this.tabPosition);
      tab.disabled.forEach((item, index) => {
        this.disabled.splice(index, 1, item);
      });
      this.tabPosition = tab.tabPosition;
      this.disabled = [true, true];
    },
    // 表头时间改变，改变按日，按周，按月的选择禁用
    changeHeader(val) {
      let time_block = util.report.timeinterval(val);
      this.disabled = [true, true];
      // 按周
      if (time_block >= 8 && time_block < 32) {
        this.disabled.splice(0, 1, false);
      } else if (time_block >= 32) {
        // 按月
        this.disabled.splice(0, 2, false);
      } else {
        // 按日
        if (this.page.isDay) {
          this.tabPosition = "byDay";
        } else {
          this.disabled.splice(0, 1, false);
          this.tabPosition = "byWeek";
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.table_min {
  min-height: 200px;
}
</style>
